module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row general-info-row"
  }, [_c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 items-center flex"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "tc general-info-data mt3"
  }, [_vm._v("\n        " + _vm._s(_vm.activeTeachers) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "general-info-label mt3"
  }, [_vm._v("Active Teachers")]), _vm._v(" "), _c('div', {
    staticClass: "tc mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.active_teachers_tooltip),
      expression: "active_teachers_tooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 items-center flex"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "tc general-info-data mt3"
  }, [_vm._v("\n        " + _vm._s(_vm.activeStudents) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tc general-info-label mt3"
  }, [_vm._v("Active Students")]), _vm._v(" "), _c('div', {
    staticClass: "tc mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.active_students_tooltip),
      expression: "active_students_tooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 items-center flex"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "tc general-info-data mt3"
  }, [_vm._v("\n        " + _vm._s(_vm.numberOnlineActivitiesCreated) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tc general-info-label mt3"
  }, [_vm._v("Written RoundTables Created")]), _vm._v(" "), _c('div', {
    staticClass: "tc mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.roundtable_discussions_tooltip),
      expression: "roundtable_discussions_tooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 items-center flex"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "tc general-info-data mt3"
  }, [_vm._v("\n        " + _vm._s(_vm.numberOnlineActivitiesRun) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tc general-info-label mt3"
  }, [_vm._v("Written RoundTables Run")]), _vm._v(" "), _c('div', {
    staticClass: "tc mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.roundtable_discussions_run_tooltip),
      expression: "roundtable_discussions_run_tooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 items-center flex"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "tc general-info-data mt3"
  }, [_vm._v("\n        " + _vm._s(_vm.numberLiveActivitiesCreated) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tc general-info-label mt3"
  }, [_vm._v("Verbal RoundTables Created")]), _vm._v(" "), _c('div', {
    staticClass: "tc mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.roundtable_discussions_tooltip),
      expression: "roundtable_discussions_tooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 items-center flex"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "tc general-info-data mt3"
  }, [_vm._v("\n        " + _vm._s(_vm.numberLiveActivitiesRun) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tc general-info-label mt3"
  }, [_vm._v("Verbal RoundTables Run")]), _vm._v(" "), _c('div', {
    staticClass: "tc mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.roundtable_discussions_tooltip),
      expression: "roundtable_discussions_tooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 items-center flex"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "tc general-info-data mt3"
  }, [_vm._v("\n        " + _vm._s(_vm.topicsUsed) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "general-info-label mt3"
  }, [_vm._v("Universe Topics Used")]), _vm._v(" "), _c('div', {
    staticClass: "tc mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.topics_used_tooltip),
      expression: "topics_used_tooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-16bd5478!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/analytics/adminPortalAnalyticsGeneralInfo.vue
// module id = 2150
// module chunks = 61